import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { useLocation } from 'react-router'
import authProvider from '../../../../../core/AuthenticationProvider'
import { TransferInformationPopup } from '../../../../cartAndOrders/common/poup/TransferInformationPopup'
import {
  selectDiscountOrder,
  selectVoucher,
} from '../../../../cartAndOrders/store/slice'
import { getBankTransferInfo } from '../../../../cartAndOrders/store/thunk'
import { SizeTracker } from '../../../../common/SizeTracker'
import UseDevicePixelRatio from '../../../../common/hooks/useDevicePixelRatio'
import useViewport from '../../../../common/hooks/useViewport'
import { Checkbox } from '../../../../common/html/checkbox'
import { Element } from '../../../../common/html/element'
import { Icon } from '../../../../common/html/icon'
import { Popup } from '../../../../common/popup'
import { ScrollComponent } from '../../../../common/scrollComponent'
import EventEmitter, {
  SHOW_POPUP_CONFIRMATION,
} from '../../../../helpers/EventEmitter'
import classes from '../../../index.module.scss'
import {
  changeSubscriptionDetailsParams,
  selectBuyPackage,
  selectCheckRules,
  selectContractionForm,
  selectInvoiceReceivingForm,
  selectSubscriptionDetailsParams,
  setContractionForm,
} from '../../store/slice'
import {
  getSampleContract,
  postSubscriptionAndPackageOrders,
} from '../../store/thunk'
import { PayNowButton } from '../PayNowButton'
import { TermsAndConditionPayment } from '../TermsAndConditionPayment'
import {
  checkAllValidFields,
  checkEmailValid,
  checkPhoneValid,
  removeEmptyItem,
} from '../helper'
import { ContractForm } from '../popupContract/ContractForm'
import { IS_VALID_FIELDS } from '../popupContract/constants'
import { InvoiceReceivingInfo } from './InvoiceReceivingInfo'
import { PaymentMethod } from './PaymentMethod'
import { BANK_TRANSFER_TYPE, PAYMENT_METHOD, TYPE_TRANSFER } from './constants'

const POPUP = {
  MAX_WIDTH: 900,
  WIDTH_PROPORTION: '80vw',
}

export const PopupBuyNow = ({
  isShow,
  setIsShow,
  isBuyPackage,
  userProfile,
  loadingUserProfile,
  onClosePlan = () => {},
}) => {
  const dispatch = useDispatch()

  const { height } = useViewport()

  const location = useLocation()

  const devicePixelRatio = UseDevicePixelRatio()

  const locale = useSelector((state) => state.i18n.locale)
  const contractionForm = useSelector(selectContractionForm)
  const invoiceReceivingForm = useSelector(selectInvoiceReceivingForm)
  const buyPackage = useSelector(selectBuyPackage)
  const subscriptionDetails = useSelector(selectSubscriptionDetailsParams)
  const isCheckedTermsAndCondition = useSelector(selectCheckRules)

  const dataVoucher = useSelector(selectVoucher)
  const discountOrder = useSelector(selectDiscountOrder)

  const listPackage = buyPackage?.listPackage

  const [isDisplayContract, setIsDisplayContract] = useState(false)
  const [isValid, setIsValid] = useState(IS_VALID_FIELDS)
  const [isValidInvoiceForm, setIsValidInvoiceForm] = useState(IS_VALID_FIELDS)
  const [isShowTransferInfo, setIsShowTransferInfo] = useState(false)
  const [loading, setLoading] = useState(false)

  const [paymentMethod, setPaymentMethod] = useState(
    Object.values(PAYMENT_METHOD)[0],
  )
  const [currencyType, setCurrencyType] = useState(
    Object.values(TYPE_TRANSFER)[0],
  )
  const [bankTransferType, setBankTransferType] = useState(
    Object.values(BANK_TRANSFER_TYPE)[0],
  )

  const handlePayNow = () => {
    let packageDetails = []
    let contractInfo = {}
    let packageParams = {}
    let subscriptionParams = {}
    let paymentCurrencyParams = {}

    setIsValidInvoiceForm({
      phone: checkPhoneValid(invoiceReceivingForm.phone),
      invoiceReceivingEmail: checkEmailValid(
        invoiceReceivingForm.invoiceReceivingEmail,
      ),
      customerName: Boolean(invoiceReceivingForm.customerName),
      companyName: Boolean(invoiceReceivingForm.companyName),
      companyAddress: Boolean(invoiceReceivingForm.companyAddress),
      taxCode: Boolean(invoiceReceivingForm.taxCode),
    })

    if (isDisplayContract) {
      setIsValid({
        companyName: Boolean(contractionForm.companyName),
        companyAddress: Boolean(contractionForm.companyAddress),
        companyPhone: checkPhoneValid(contractionForm.companyPhone),
        companyEmail: checkEmailValid(contractionForm.companyEmail),
        taxCode: Boolean(contractionForm.taxCode),
        title: Boolean(contractionForm.title),
        representative: Boolean(contractionForm.representative),
      })
    }

    if (
      !checkPhoneValid(invoiceReceivingForm.phone) ||
      !checkEmailValid(invoiceReceivingForm.invoiceReceivingEmail) ||
      !Boolean(invoiceReceivingForm.customerName) ||
      !Boolean(invoiceReceivingForm.companyName) ||
      !Boolean(invoiceReceivingForm.companyAddress) ||
      !Boolean(invoiceReceivingForm.taxCode)
    ) {
      return
    }

    if (isDisplayContract) {
      if (
        !Boolean(contractionForm.companyName) ||
        !Boolean(contractionForm.companyAddress) ||
        !checkPhoneValid(contractionForm.companyPhone) ||
        !checkEmailValid(contractionForm.companyEmail) ||
        !Boolean(contractionForm.taxCode) ||
        !Boolean(contractionForm.title) ||
        !Boolean(contractionForm.representative)
      ) {
        return
      }
    }

    if (listPackage.length) {
      packageDetails = listPackage
        .filter((key) => !key.isContactUs)
        .map((item) => ({
          fiinGateReportTypeId: item.packageTypeId,
          pricingPackageId: item.pricingPackageId,
          quantity: Number(item.volume),
          price: item.unitPrice,
          discountId: item?.discountId,
          discountPercentage: item?.discountPercentage,
        }))
    }
    if (!isBuyPackage) {
      packageParams = {}
    } else {
      packageParams = {
        details: packageDetails,
        voucherCode: dataVoucher.code,
        discountId: discountOrder?.id,
      }
    }

    if (subscriptionDetails) {
      subscriptionParams = subscriptionDetails
    } else {
      subscriptionParams = {}
    }

    if (isDisplayContract) {
      contractInfo = {
        currencyCode: currencyType,
        phone: contractionForm.companyPhone,
        languageCode: contractionForm?.languageCode || locale,
        email: contractionForm?.companyEmail,
        companyName: contractionForm.companyName,
        companyAddress: contractionForm.companyAddress,
        taxCode: contractionForm.taxCode,
        representative: contractionForm.representative,
        title: contractionForm.title,
        fax: contractionForm?.fax,
        otherContacts: contractionForm?.otherContactDetails,
      }
    }

    if (paymentMethod === PAYMENT_METHOD.BANK_TRANSFERS) {
      paymentCurrencyParams = currencyType
    }

    if (paymentMethod === PAYMENT_METHOD.POST_PAID) {
      paymentCurrencyParams = TYPE_TRANSFER.VND
    }

    const params = {
      order: removeEmptyItem({
        package: packageParams,
        ...invoiceReceivingForm,
        receiveContract: isDisplayContract,
        contractInfo: contractInfo,
        subscription: subscriptionParams,
        paymentMethod: paymentMethod,
        paymentCurrency: paymentCurrencyParams,
      }),
    }

    const allowSendRequest = isDisplayContract
      ? checkAllValidFields(isValidInvoiceForm) && checkAllValidFields(isValid)
      : checkAllValidFields(isValidInvoiceForm)

    if (allowSendRequest) {
      setLoading(true)
      dispatch(postSubscriptionAndPackageOrders(params))
        .unwrap()
        .then((res) => {
          const transactionCode = res?.data || null
          if (paymentMethod === PAYMENT_METHOD.BANK_TRANSFERS) {
            dispatch(
              getBankTransferInfo({
                TransactionCode: transactionCode,
                CurrencyCode: currencyType,
              }),
            )
              .unwrap()
              .then(() => {
                setLoading(false)
                setIsShowTransferInfo(true)
              })
              .catch(() => {
                setLoading(false)
              })
          }

          if (paymentMethod === PAYMENT_METHOD.POST_PAID) {
            if (res.success) {
              handleClose()
              EventEmitter.dispatch(
                SHOW_POPUP_CONFIRMATION,
                'userManagement.paymentMethod.CONFIRM_POST_PAID',
              )
            }
          }

          if (paymentMethod === PAYMENT_METHOD.CARD) {
            authProvider.getUser().then((user) => {
              setLoading(false)

              const navigateLink = [
                process.env.REACT_APP_SERVICE_ENDPOINT,
                '/Transaction/PaymentCardRedirect',
                `?PaymentGate=${bankTransferType}`,
                `&TransactionCode=${transactionCode}`,
                `&access_token=${user.access_token}`,
              ].join('')
              window.open(navigateLink, '_self')

              const { PaymentStatus } = new Proxy(
                new URLSearchParams(location.search),
                {
                  get: (searchParam, prop) => searchParam.get(prop),
                },
              )

              if (PaymentStatus === 'TransactionSuccess') {
                setTimeout(() => {
                  EventEmitter.dispatch(
                    SHOW_POPUP_CONFIRMATION,
                    'userManagement.paymentMethod.CONFIRM_POST_PAID',
                  )
                }, 3000)
              }
            })
            return
          }
          dispatch(changeSubscriptionDetailsParams({}))
        })
        .catch(() => {})
    }
  }

  const handleClose = () => {
    setIsShow(false)
  }

  const setContraction = (form) => {
    dispatch(setContractionForm(form))
  }

  const handleGetSampleContract = () => {
    dispatch(getSampleContract())
  }

  const onCloseTransferInfo = () => {
    setIsShowTransferInfo(false)
    handleClose()
    setIsShow(false)
    onClosePlan()
  }

  return (
    <>
      {isShow && !isShowTransferInfo && (
        <Popup
          zIndexPopup={99}
          appendStyleContent={{
            padding: '20px',
            backgroundColor: '#F3F3F3',
            width: `calc(${POPUP.WIDTH_PROPORTION}*${devicePixelRatio})`,
            maxWidth: POPUP.MAX_WIDTH,
            height: height * 0.95,
            borderRadius: '4px',
            position: 'relative',
          }}
        >
          <SizeTracker
            renderTopComponent={() => <TitlePopup handleClose={handleClose} />}
            renderBottomComponent={() => (
              <BottomBtn
                loading={loading}
                handlePayNow={handlePayNow}
                disabled={
                  (!isCheckedTermsAndCondition &&
                    paymentMethod !== PAYMENT_METHOD.POST_PAID) ||
                  (!Object.values(isValidInvoiceForm).every(Boolean) &&
                    paymentMethod !== PAYMENT_METHOD.POST_PAID) ||
                  (isDisplayContract && !Object.values(isValid).every(Boolean))
                }
              />
            )}
          >
            {(size) => {
              return (
                <div
                  style={{ height: `calc(100% - ${size.height}px)` }}
                  className={[classes.popupBuyPackage].join(' ')}
                >
                  <ScrollComponent>
                    <PaymentMethod
                      paymentMethodList={PAYMENT_METHOD}
                      paymentMethod={paymentMethod}
                      setPaymentMethod={setPaymentMethod}
                      currencyType={currencyType}
                      setCurrencyType={setCurrencyType}
                      bankTransferType={bankTransferType}
                      setBankTransferType={setBankTransferType}
                    />

                    <InvoiceReceivingInfo
                      isValid={isValidInvoiceForm}
                      setIsValid={setIsValidInvoiceForm}
                      userProfile={userProfile}
                      loading={loadingUserProfile}
                    />

                    <div className="flexRow">
                      <Checkbox
                        checked={isDisplayContract}
                        onChange={setIsDisplayContract}
                        title="userManagement.paymentMethod.CHECKBOX_CONTRACT_TITLE"
                        isCheckOnClickText
                        isI18n
                        appendStyle={{ marginTop: 12 }}
                      />
                    </div>

                    {isDisplayContract && (
                      <>
                        <Element
                          className="dFlex"
                          style={{
                            color: '#2C73E8',
                            marginTop: 12,
                            paddingBottom: 10,
                          }}
                        >
                          <Element
                            onClick={handleGetSampleContract}
                            elementName="span"
                            className="cursorPointer"
                          >
                            <Translate value="userManagement.contractInfo.SAMPLE_CONTRACT" />
                          </Element>
                        </Element>
                        <ContractForm
                          form={contractionForm}
                          setForm={setContraction}
                          isValid={isValid}
                          setIsValid={setIsValid}
                          userProfile={userProfile}
                        />
                      </>
                    )}

                    <div style={{ marginTop: 12 }}>
                      {[
                        PAYMENT_METHOD.BANK_TRANSFERS,
                        PAYMENT_METHOD.CARD,
                      ].includes(paymentMethod) && <TermsAndConditionPayment />}
                    </div>
                  </ScrollComponent>
                </div>
              )
            }}
          </SizeTracker>
        </Popup>
      )}
      <TransferInformationPopup
        isShow={isShowTransferInfo}
        onClose={onCloseTransferInfo}
        type={currencyType}
      />
    </>
  )
}

const TitlePopup = ({ handleClose }) => {
  return (
    <Element
      className={[
        'dFlex justifyContentBetween alignItemsCenter',
        classes.header,
      ].join(' ')}
      style={{
        borderBottom: '1px solid #e5e5e8',
      }}
    >
      <Element
        elementName="span"
        style={{
          fontSize: 20,
          fontWeight: 500,
          lineHeight: '24px',
          color: '#0553A5',
          width: `calc(100% - 30px)`,
        }}
      >
        <Translate value="userManagement.buyPackage.PLACE_ORDER" />
      </Element>
      <Element onClick={handleClose}>
        <Icon
          className="icon-delete"
          style={{ fontSize: 12, color: '#9C9C9C' }}
        />
      </Element>
    </Element>
  )
}

const BottomBtn = ({ handlePayNow, disabled, loading }) => {
  return (
    <div
      className="dFlex justifyContentEnd"
      style={{
        paddingTop: 5,
      }}
    >
      <PayNowButton
        onClick={handlePayNow}
        title="userManagement.paymentInformation.PAY_NOW"
        disabled={disabled}
        loading={loading}
      />
    </div>
  )
}
